import { frontendURL } from '../../../helper/URLHelper';
import LeadsIndex from '../laisLeads/pages/LeadsIndex.vue';

export const myClientsGroupedRoute = {
  path: frontendURL('accounts/:accountId/menu-meus-clientes'),
  name: 'my-clients-grouped',
  component: LeadsIndex,
  meta: { referenceAuthenticated: true },
};

export default myClientsGroupedRoute;
